module.exports = __webpack_public_path__ + "img/gomb-fokusz-aktiv.d520b664.png";